module.exports = __webpack_public_path__ + "static/media/logo_black.1f83e4b8.svg";